var _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompareFill = function SvgCompareFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.5 16.064h9.816v-3H12.685v3H22.5v23.311h-6.157v3h15.315v-3H25.5zm-3-10.439h3V11.2h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.901 18.665-6.935 11.917 6.935 2.744 6.934-2.744zm-23.801 0L5.166 30.582l6.934 2.744 6.934-2.744z"
  })))));
};
export default SvgCompareFill;